import { Slider } from "@components/atoms/Slider"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Category Cards",
  category: "layouts",
  icon: "slides",
  description: "A row of categories or genres",
  keywords: ["category", "genre", "tile"],
  tags: ["#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("hero/category-card-row", (props) => {
  const heading = useInlineEditableValue("title", "Browse by Category")
  return (
    <div data-mixpanel-block="Category Card Row" data-mixpanel-heading={heading[0]}>
      <div className="w-grid mx-auto text-fg">
        <EditableText
          as="h2"
          store={heading}
          defaultValue="Browse by Category"
          className="type-title-m mb-5"
          plainText
        />
      </div>
      {env.admin && (
        <InnerBlocks
          orientation="horizontal"
          allowedBlocks={["hero/category-card-item"]}
          defaultBlocks={[["hero/category-card-item", {}]]}
          adminClassName="grid-auto [&>.wp-block]:col-span-3 gap-y-4"
        />
      )}
      {!env.admin && (
        <Slider arrows gridInsert scrollerClass="flex gap-grid-gutter px-grid-margin-full">
          <InnerBlocks wrapBlock={(child) => <div className="w-[14em] lg:w-[18em] flex-none">{child}</div>} />
        </Slider>
      )}
    </div>
  )
})
